import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import Button from 'react-bootstrap/esm/Button'
import { toast } from 'react-toastify'
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import Loading from '../../Components/Layout/Styled/Loading'
import ReactPlaceholder from 'react-placeholder/lib'
import { FormCustom, Input } from '../../Components/Form/Form'

const Encuesta1 = () => {
  const [encuesta, setEncuesta] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState({
    p_name_user: '',
    p_age_user: '',
    p_job_user: ''
  })

  useEffect(() => {
    Controllers.encuesta.encuesta_1_questions().then((res) => {
      setEncuesta(res.data/* .filter(ec => ec.yes_no === true) */)
      setReady(true)
    })
  }, [])

  const onSubmit = () => {
    let hasError = false
    let questionError = null;

    encuesta.forEach((section) => {
      if (section.yes_no === true) {
        if (!hasError) {
          if (!section.yes_no_options.some(op => op.checked === true)) {
            hasError = true
            questionError = `${section.title}`
          }
        }
      }

      section.items.forEach((item) => {
        if (!hasError) {
          if (!section.yes_no && !item.options.some(op => op.checked === true)) {
            hasError = true
            questionError = `${item.id}.- ${section.title}`
          } else if (section.yes_no && section.yes_no_options.some(op => op.checked === true && op.value === 'SI') && !item.options.some(op => op.checked === true)) {
            hasError = true
            questionError = `${item.id}.- ${section.title}`
          }
        }
      })
    })

    if (hasError) {
      Helpers.toast.construct({
        message: `Debe seleccionar una opción en la pregunta: ${questionError}`,
        response: 'info',
        toast
      })
      return
    }

    setIsLoading(true)
    Controllers.encuesta.encuesta_1_save({
      p_encuesta: JSON.stringify(encuesta),
      ...user
    }).then(() => {
      setIsLoading(false)
      setShowPopup(true)
    })
  }

  return (
    <div className="container mt-4 mb-5">
      <div className="form-row">
        <div className="col-12">
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <h6 className='text-primary'>CUESTIONARIO PARA IDENTIFICAR LOS FACTORES DE RIESGO PSICOSOCIAL Y EVALUAR EL ENTORNO ORGANIZACIONAL EN LOS CENTROS DE TRABAJO</h6>
              </div>

              <ReactPlaceholder rows={15} ready={ready} showLoadingAnimation>
                <FormCustom viewSubmit={false} onSubmit={onSubmit}>
                  <Input
                    text="Nombres*"
                    placeholder="Nombres"
                    classNameParent="col-12 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_name_user: e.currentTarget.value })}
                    maxLength={100}
                    minLength={5}
                  />
                  <Input
                    type="number"
                    text="Edad*"
                    placeholder="Edad"
                    classNameParent="col-md-6 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_age_user: e.currentTarget.value })}
                    min={15}
                    max={99}
                  />
                  <Input
                    text="Puesto de Trabajo*"
                    placeholder="Nombres"
                    classNameParent="col-md-6 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_job_user: e.currentTarget.value })}
                    maxLength={100}
                    minLength={5}
                  />

                  <div className="col-12">
                    <div className="d-flex flex-column mt-3">
                      {React.Children.toArray(encuesta.map((section, idxSec) => {

                        return <div className='mb-4'>
                          <div className='mb-2'>
                            <small>{section.title}</small>
                            {section.yes_no === true && <div>

                              {React.Children.toArray(section.yes_no_options.map((ynOpt, idxynOpt) => {
                                return <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`section_${section.id}_yes_no_option_${idxynOpt}`}
                                    name={`section_${section.id}_yes_no`}
                                    value={ynOpt.value}
                                    checked={ynOpt.checked === true}
                                    onChange={() => {
                                      const newEncuesta = [...encuesta]
                                      newEncuesta[idxSec].yes_no_options = newEncuesta[idxSec].yes_no_options.map(op => {
                                        op.checked = false
                                        return op
                                      })

                                      newEncuesta[idxSec].yes_no_options[idxynOpt].checked = true

                                      newEncuesta[idxSec].items = newEncuesta[idxSec].items.map(it => {
                                        it.options = it.options.map(op => {
                                          op.checked = false
                                          return op
                                        })

                                        return it
                                      })

                                      setEncuesta(newEncuesta)
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`section_${section.id}_yes_no_option_${idxynOpt}`}>
                                    {ynOpt.title}
                                  </label>
                                </div>
                              }))}
                            </div>}

                            {section.yes_no && section.yes_no_options.some(op => op.checked === true && op.value === 'SI') && <div className='mt-2'>
                              <small>{section.subtitle}</small>
                            </div>}
                          </div>
                          {(!section.yes_no || (section.yes_no && section.yes_no_options.some(op => op.checked === true && op.value === 'SI'))) && <>
                            <div className="d-flex flex-column">
                              {React.Children.toArray(section.items.map((item, idxIt) => {

                                return <div className='mb-3'>
                                  <div className='mb-2'>
                                    <small><strong>{item.id}.- {item.title}</strong></small>
                                  </div>
                                  {React.Children.toArray(item.options.map((option, idxOpt) => {
                                    return <div className='ml-3'>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id={`section_${section.id}_item_${item.id}_option_${option.id}`} name={`section_${section.id}_item_${item.id}`}
                                          value={option.value}
                                          checked={option.checked === true}
                                          onChange={() => {
                                            const newEncuesta = [...encuesta]
                                            newEncuesta[idxSec].items[idxIt].options = newEncuesta[idxSec].items[idxIt].options.map(op => {
                                              op.checked = false
                                              return op
                                            })

                                            newEncuesta[idxSec].items[idxIt].options[idxOpt].checked = true
                                            setEncuesta(newEncuesta)
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`section_${section.id}_item_${item.id}_option_${option.id}`}>
                                          {option.title}
                                        </label>
                                      </div>
                                    </div>
                                  }))}
                                </div>
                              }))}
                            </div>
                          </>}
                        </div>
                      }))}
                    </div>

                    <div className='mb-2'>
                      <Button block type="submit">
                        Enviar Encuesta
                      </Button>
                    </div>
                  </div>
                </FormCustom>
              </ReactPlaceholder>
            </Card.Body>
          </Card>
        </div>
      </div>
      <Loading show={isLoading}>
        <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
      </Loading>
      <SweetAlert
        icon="info"
        show={showPopup}
        showCancelButton={false}
        title={<>¡Gracias por completar la encuesta!</>}
        subtitle={<>Ya puedes cerrar esta ventana</>}
      />
    </div>
  )
}

export default Encuesta1